<template>
  <Table
    ref="table"
    :layers-filters="layersFilters"
    @setLayerFeaturesFilters="setLayerFeaturesFilters"
    @deleteLayerFeaturesFilters="deleteLayerFeaturesFilters"
    :is-custom-layer="true"
    :custom-layer-data="customLayerData"
    :has-edit-buttons="true"
  />
</template>

<script>
import { get, sync } from 'vuex-pathify';

import Table from '@/components/Table.vue';

export default {
  name: 'TableWatermeters',
  components: { Table },
  computed: {
    activeTool: sync('tools/activeTool'),
    layersFilters: get('layers/layersFilters'),
    watermetersLayerId: get('admin/modulesMapping@billing.layer_id'),
    customLayerData() {
      const watermetersRouteNames = {
        waterDissolutionWatermeters: 'waterDissolutionWatermetersInfo',
        waterDissolutionWatermetersInfo: 'waterDissolutionWatermetersInfo',
        legalization: 'legalizationInfo',
        legalizationInfo: 'legalizationInfo',
        billingAnomalyDetection: 'billingAnomalyDetectionInfo',
        billingAnomalyDetectionInfo: 'billingAnomalyDetectionInfo',
      };
      return {
        routeName: watermetersRouteNames[this.$route.name] || 'layerFeature',
        eventName: 'toggleWatermeters',
        filterEventName: 'toggleWatermetersFilter',
        layerId: this.watermetersLayerId,
      };
    },
  },
  methods: {
    deleteLayerFeaturesFilters(currentLayerId) {
      this.$store.set('layers/DELETE_LAYERS_FILTERS!', currentLayerId);
    },
    setLayerFeaturesFilters(filter) {
      this.$store.set('layers/SET_LAYERS_FILTERS!', filter);
    },
  },
  mounted() {
    this.$once('hook:beforeDestroy', () => {
      this.$nextTick(() => {
        this.activeTool = undefined;
      });
      this.$root.$emit('toggleWatermeters', false);
    });
  },
};
</script>

<style lang="scss">
.textarea--custom {
  textarea {
    max-height: 400px;
  }
}
</style>
